function Participants({ participants }) {
    return (
        <div className="Messages-participants">
            {participants.map((participant, index) => (
                <div className="Messages-participant" key={index}>
                    <span className="Messages-participant-image">
                        {participant?.image && (
                            <img src={participant?.image} className="Messages-participant-image-img" />
                        )}
                    </span>
                    <p className="Messages-participant-name">{participant.name}</p>
                    {participant?.subline && <p className="Messages-participant-subline">{participant.subline}</p>}
                </div>
            ))}
        </div>
    );
}

export default Participants;
